import * as React from "react";

import DialogContext, { ContextValue } from "./DialogContext";

export default function useDialog(): ContextValue {
    return React.useContext(DialogContext);
}
